import {
    Button,
    ButtonGroup,
    Card,
    CardBody,
    Flex,
    Input,
    Table,
    TableContainer,
    Tbody,
    Td,
    Text,
    Textarea,
    Tr,
} from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { editByAdmin } from "../../../services/CustomerAPI";

export const AdminPostForEdit = (props) => {
    const [file, setFile] = useState(null); // 파일 임시 저장 변수

    const inputRef = useRef(null);
    const buttonClick = () => {
        inputRef.current.click();
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const [formData, setFormData] = useState({
        publisher: "관리자",
        title: props.complement.title,
        content: props.complement.content,
        file: props.complement.file,
    });

    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;

        const inputValue = type === "checkbox" ? checked : value;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: inputValue,
        }));
    };

    const saveClick = () => {
        if (window.confirm("게시글을 수정하시겠습니까?")) {
            confirmBlank();
        } else {
            alert("게시글 수정이 취소되었습니다.");
        }
    };

    const confirmBlank = () => {
        if (formData.title.length > 40) {
            alert("제목의 길이는 40글자를 초과할 수 없습니다!");
        } else if (formData.title === "" || isSpaceWord(formData.title)) {
            alert("제목을 입력해주세요! 공백은 인정되지 않습니다.");
        } else if (formData.content === "" || isSpaceWord(formData.title)) {
            alert("내용을 입력해주세요! 공백은 인정되지 않습니다.");
        } else {
            handleFormEditAdmin();
        }
    };

    const isSpaceWord = (word) => {
        // 공백으로만 이루어진 경우 체크
        const removedWord = word.replace(/\s/g, "");
        if (removedWord === "") {
            return true;
        }
        return false;
    };

    const handleFormEditAdmin = async () => {
        try {
            await editByAdmin(props.id, formData, file);
            alert("게시글 수정이 완료되었습니다!");
            props.goList();
        } catch (error) {
            alert("게시글 수정에 실패하였습니다!");
        }
    };

    const cancelClick = () => {
        alert("게시글 수정이 취소되었습니다.");
        props.goList();
    };

    return (
        <Flex
            mt="20px"
            justifyContent="center"
            justifyItems="center"
            alignContent="center"
            alignItems="center"
            direction="column"
        >
            <Card w="90%" variant="outline">
                <CardBody>
                    <TableContainer>
                        <Table size="sm">
                            <Tbody>
                                <Tr>
                                    <Td>
                                        <Text as="b" fontSize="2xl">
                                            글쓴이
                                        </Text>
                                    </Td>
                                    <Td>
                                        <Input
                                            name="publisher"
                                            borderColor="#D7D7D7"
                                            w="100px"
                                            type="text"
                                            fontSize="xl"
                                            value={formData.publisher}
                                            onChange={handleInputChange}
                                            readOnly
                                        />
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td>
                                        <Text as="b" fontSize="2xl">
                                            제목
                                        </Text>
                                    </Td>
                                    <Td>
                                        <Input
                                            name="title"
                                            borderColor="#D7D7D7"
                                            type=""
                                            fontSize="xl"
                                            value={formData.title}
                                            onChange={handleInputChange}
                                        />
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td>
                                        <Text as="b" fontSize="2xl">
                                            내용
                                        </Text>
                                    </Td>
                                    <Td>
                                        <Textarea
                                            name="content"
                                            borderColor="#D7D7D7"
                                            h="140px"
                                            type="content"
                                            fontSize="xl"
                                            value={formData.content}
                                            onChange={handleInputChange}
                                        />
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td>
                                        <Text as="b" fontSize="2xl">
                                            파일
                                        </Text>
                                    </Td>
                                    <Td>
                                        <Flex>
                                            <Input
                                                name="file"
                                                width="150px"
                                                placeholder={
                                                    formData.file ? formData.file.split("/")[4] : "등록된 파일 없음"
                                                }
                                                borderColor="#D7D7D7"
                                                fontSize="xl"
                                                value={file ? file.name : ""}
                                                readOnly
                                            />
                                            <Button
                                                ml="5px"
                                                width="80px"
                                                fontSize="xl"
                                                height="25px"
                                                size="md"
                                                colorScheme="red"
                                                onClick={buttonClick}
                                            >
                                                파일 선택
                                            </Button>
                                            <input
                                                style={{ display: "none" }}
                                                ref={inputRef}
                                                type="file"
                                                accept="*/*"
                                                onChange={fileChange}
                                            />
                                        </Flex>
                                    </Td>
                                </Tr>
                            </Tbody>
                        </Table>
                    </TableContainer>
                </CardBody>
            </Card>
            <ButtonGroup mt="10px" justifyContent="center" spacing="3">
                <Button onClick={() => cancelClick()} colorScheme="gray" size="lg" fontSize="2xl">
                    취소
                </Button>
                <Button onClick={() => saveClick()} colorScheme="red" size="lg" fontSize="2xl">
                    확인
                </Button>
            </ButtonGroup>
        </Flex>
    );
};

export default AdminPostForEdit;
